import React from "react";

import { HubTableHeader, InputLabel } from "../../components";

const required = true;

const headCells = [
  {
    id: "status",
    label: "Status",
  },
  {
    id: "wo",
    label: "WO #",
    required,
  },
  {
    id: "lot",
    label: "Lot #",
    required,
  },
  {
    id: "trees",
    label: "Trees",
    required,
  },
  {
    id: "sync",
    label: "",
  },
  {
    id: "qty",
    label: "Qty",
    required,
  },
  {
    id: "estimatedCompleted",
    label: "Exp. Qty",
    required,
  },
  {
    id: "startDate",
    label: "Start Date",
    required,
  },
  {
    id: "dueDate",
    label: "Box Date",
    required,
  },
  {
    id: "projectedDate",
    label: "Projected Date",
  },
  {
    id: "shipDate",
    label: "Ship Date",
    required,
  },
];

export const OrderLineItemsHeader = () => {
  const ITEMS = headCells.map((cell) => ({
    id: cell.id,
    label: cell?.required ? (
      <InputLabel label={cell.label} required disableMargin />
    ) : (
      cell.label
    ),
  }));
  return (
    <HubTableHeader
      items={ITEMS}
      includeCheckbox={false}
      sx={{ backgroundColor: "hubColors.greyLighter" }}
    />
  );
};

export default OrderLineItemsHeader;
